import Injection = EECore.Injection;
import Model from "../models/promotion/promotionModel";
import PromotionService from "../../services/promotion/promotionService";

@Injection.injectableClass("ElectronicFeaturesPromotion")
export default class ElectronicFeatures implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("ElectronicFeaturesPromotion", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("ElectronicFeaturesPromotion", EECore.Registrations.HTML_HELPER)
  private htmlHelper: EECore.HtmlHelper;

  @Injection.injectableProperty("ElectronicFeaturesPromotion", "PromotionService")
  private promotionService: PromotionService;

  @Injection.injectableProperty("ElectronicFeaturesPromotion", EECore.Registrations.TEALIUM)
  private tealium: EECore.Tealium;

  promotionData: any;

  constructor(templateFactory: EECore.UI.TemplateFactory, htmlHelper: EECore.HtmlHelper, promotionService: PromotionService, tealium: EECore.Tealium) {
    this.templateFactory = templateFactory;
    this.htmlHelper = htmlHelper;
    this.promotionService = promotionService;
    this.tealium = tealium;
  }

  load() {

    return new EECore.Promise<Element, string>((resolve, reject) => {
      const contentRequest = this.promotionService.getElectronicFeaturesContent();
      contentRequest.then((content) => {
        const promotionElement = this.render(content);
        resolve(promotionElement);
        this.bindEvents(promotionElement);
        this.scheduleDisplay(promotionElement);
      }).catch(() => {
        reject("Could not get the promotion information");
      });
    });
  }

  private render(content: string): Element {
    const model: Model = { content: content };
    const template = this.templateFactory.getTemplate("ElectronicFeatures", model);
    this.customizeContent(template);

    return template;
  }

  private customizeContent(content: Element) {
    if (this.promotionData.contest) {
      this.htmlHelper.addCssClass(content.querySelector(".we_overlayBannerContestInd"), "show");
      this.htmlHelper.addCssClass(content.querySelector("#conditionsLabelContest"), "show");
      content.querySelector("#we_overlayBannerText").innerHTML = this.promotionData.contest.text;
      content.querySelector("#eDocBannerContestRules").setAttribute("href", this.promotionData.contest.contestRulesUrl);
      if (this.promotionData.contest.contestImageUrl) {
        (content.querySelector(".banner-image") as HTMLElement).style.backgroundImage = `url('${this.promotionData.contest.contestImageUrl}')`;
      }
    } else {
      this.htmlHelper.addCssClass(content.querySelector("#conditionsLabel"), "show");
    }

    if (this.promotionData.promoterRule === "CAN_REMIND_LATER") {
      (content.querySelector("#eDocBannerLater") as HTMLElement).style.display = "block";
      (content.querySelector("#eDocBannerRedirect") as HTMLElement).style.display = "none";
    }
  }

  private bindEvents(content: Element) {
    const adhesionCheckbox = content.querySelector("#eDocBannerCkbAdhesion") as HTMLInputElement;
    const saveButton = content.querySelector("#eDocBannerSaveBtn");
    adhesionCheckbox.addEventListener("change", () => {
      if (adhesionCheckbox.checked)
        this.htmlHelper.removeCssClass(saveButton, "disabled");
      else
        this.htmlHelper.addCssClass(saveButton, "disabled");
    });

    const closeButtons = content.querySelectorAll(".close-button");
    for (let i = 0; i < closeButtons.length; i++) {
      closeButtons[i].addEventListener("click", () => {
        this.promotionService.updateReminder("ELECTRONIC_FEATURES").then(() => {
          this.htmlHelper.removeCssClass(content, "active");
        });
      });
    }

    saveButton.addEventListener("click", () => {
      if (!this.htmlHelper.hasCssClass(saveButton, "disabled") && adhesionCheckbox.checked) {
        const subscriptionRequest = this.promotionService.subscribeToElectronicServices();
        subscriptionRequest.then((response) => {
          const notificationEmailAddress = response.notificationEmailAddress;
          if (notificationEmailAddress) {
            content.querySelector("#eDocBannerWithNotificationEmail strong").innerHTML = notificationEmailAddress;
            (content.querySelector("#eDocBannerWithNotificationEmail") as HTMLElement).style.display = "block";
          } else {
            (content.querySelector("#eDocBannerWithoutNotificationEmail") as HTMLElement).style.display = "block";
          }

          if (this.promotionData.contest) {
            content.querySelector("#eDocBannerConfirmContestBlock a").setAttribute("href", this.promotionData.contest.contestRulesUrl);
            (content.querySelector("#eDocBannerConfirmContestBlock") as HTMLElement).style.display = "block";
          }

          (content.querySelector("#eDocBannerConfirmation") as HTMLElement).style.display = "block";
          (content.querySelector("#eDocBannerMain") as HTMLElement).style.display = "none";
        });

        subscriptionRequest.catch(() => {
          (content.querySelector("#eDocBannerError") as HTMLElement).style.display = "block";
          (content.querySelector("#eDocBannerMain") as HTMLElement).style.display = "none";
        });
      }
    });

    const noEmailLink = content.querySelector("a.persoInfoNoEmailLink");
    if (noEmailLink) {
      noEmailLink.addEventListener("click", () => {
        this.tealium.trackLink("EdocEmailLink", "EDoc_NoEmail", "EdocBanner");
      });
    }

    const changeEmailLink = content.querySelector("a.persoInfoChangeEmailLink");
    if (changeEmailLink) {
      changeEmailLink.addEventListener("click", () => {
        this.tealium.trackLink("EdocEmailLink", "EDoc_ChangeEmail", "EdocBanner");
      });
    }

    const contestRuleLink = content.querySelector("#contestBlock a");
    if (contestRuleLink) {
      contestRuleLink.addEventListener("click", () => {
        this.tealium.trackLink("EdocLink", "EDoc_ContestRule", "EdocBanner");
      });
    }
  }

  private scheduleDisplay(content: Element) {
    (content.querySelector(".we_overlayBannerContent") as HTMLElement).style.display = "block";
    setTimeout(() => {
      this.htmlHelper.addCssClass(content, "active");
    }, 500);
  }
}